import { UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';

export enum QueryKey {
	ApprovalRequests = 'approval-requests',
	Awards = 'awards',
	Bonus = 'bonus',
	Bonuses = 'bonuses',
	BonusFeedMeta = 'bonus-feed-meta',
	BonusesInfinite = 'bonuses-infinite',
	CelebrationsWidget = 'celebrations-widget',
	Company = 'company',
	FeaturedRewards = 'featured-rewards',
	FeedbackResponses = 'feedback-responses',
	GIFs = 'gifs',
	GlobalSearch = 'global-search',
	Hashtags = 'hashtags',
	Leaderboard = 'leaderboard',
	Recipients = 'recipients',
	Rewards = 'rewards',
	UserProfile = 'recognition-user',
	Users = 'users',
}

export type MutationOptions<T = unknown, U = unknown> = Omit<UseMutationOptions<U, unknown, T>, 'mutationFn'>;

export type QueryOptions<T = unknown> = Omit<UseQueryOptions<T, unknown, T>, 'queryFn' | 'queryKey'>;
